import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { appCommonConstants } from '../../../../app.constants';
import { AppEventService } from '../../../../services/event.service';
import { AppNotificationService, INotifyDataType } from '../../../../services/notification.service';

@Component({
  selector: 'app-notifier-counter',
  standalone: true,
  imports: [
    CommonModule
  ],
  template: `<span [ngSwitch]="count === 0" [title]="title">
              <i *ngSwitchCase="true" class="fas fa-bell fa-lg"></i>
              <span *ngSwitchCase="false" class="fa-stack">
                <span class="fa fa-circle fa-stack-2x text-danger"></span>
                <b class="fa-stack-1x" style="color: #fff;" [ngStyle]="{'font-size': fontSize+'px'}">{{count}}</b>
              </span>
            </span>`,
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: '0' }),
        animate('.25s ease-out', style({ opacity: '1' })),
        transition(':leave', [
          style({ opacity: '1' }),
          animate('.25s ease-out', style({ opacity: '0' })),
        ]),
      ])
    ])
  ]
})

export class AppNotifierCounterComponent {
  constructor(
    private eventService: AppEventService,
    private notificationService: AppNotificationService,
    private translate: TranslateService) {
    this.count = this.notificationService.unreadedCount();

    // Sottoscrizione all'evento di modifica notifiche
    this.eventService.on<INotifyDataType[]>(appCommonConstants.events.notifications.change).subscribe(message => {
      this.count = this.notificationService.unreadedCount();
    });

    // Sottoscrizione all'evento di nuove notifiche
    this.eventService.on<INotifyDataType[]>(appCommonConstants.events.notifications.new).subscribe(message => {
      this.count = this.notificationService.unreadedCount();
    });

    // Sottoscrizione all'evento di cancellazione notifiche
    this.eventService.on<INotifyDataType[]>(appCommonConstants.events.notifications.remove).subscribe(message => {
      this.count = this.notificationService.unreadedCount();
    });
  }

  public count = 0;

  /** Ritorna la dimensione del font */
  public get fontSize(): number {
    const baseSize = 14;
    const sizeReductionFactor = 2; // Riduzione per ogni cifra extra
    return this.count < 10
      ? baseSize
      : baseSize - ((this.count ?? 0).toString().length - 1) * sizeReductionFactor;
  }

  /** Ritorna il title da visualizzare in caso ci siano messaggi da leggere */
  public get title(): string {
    return this.count > 0 ? this.translate.instant("WORD.Hai {{count}} nuove notifiche", { count: this.count })
      : this.translate.instant("WORD.Nessuna nuova notifica");
  }
}
